import React from 'react';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';

/**
 * Similar to ThreeColumns component, TwoColumns component has a placeholder which can
 * be any component chosen by the content author
 */
const DocumentComponent = ({ fields = {}, rendering }) => (
  <div className={clsx('terms', 'add-margins', rendering?.params?.Styles)}>
    <div className="container">
      <div className="row">
        <div className="col-md-4">
          <h2 className="columnHeading">
            <Text field={fields?.heading} />
          </h2>
        </div>
        <div className="col-md-8">
          <div className="row">
            <Placeholder name="jss-blocks" rendering={rendering} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DocumentComponent;
